export default "__VITE_ASSET__CqIR$QYN__"